<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="EPI"><span class="ePub-I">Lie to me</span></p>
<p class="EPI"><span class="ePub-I">I promise, I’ll believe</span></p>
<p class="EPI"><span class="ePub-I">Lie to me</span></p>
<p class="EPI-1"><span class="ePub-I">But please don’t leave.</span></p>
<p class="EPIS">—Sheryl Crow</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?c7a41d4a